import type { HTMLAttributes, InputHTMLAttributes } from 'react'
import styled, { DefaultTheme } from 'styled-components'
import { ToggleProps, HandleProps, InputProps, ToggleThemeVariant, variants } from './types'

type StyledToggleBoxProps = HTMLAttributes<HTMLDivElement> &
  Partial<InputHTMLAttributes<HTMLInputElement>> &
  Pick<ToggleProps, 'checked' | 'variant'>

type ThemedProps = {
  theme: DefaultTheme
} & ToggleProps

const getToggleVariantProp =
  (prop: keyof ToggleThemeVariant) =>
  ({ theme, variant = variants.DEFAULT }: ThemedProps) => {
    return theme.toggle[variant][prop]
  }

export const Handle = styled.div<HandleProps>`
  background-color: ${({ checked }) =>
    checked ? getToggleVariantProp('backgroundHandleActive') : getToggleVariantProp('backgroundHandleInactive')};
  border-radius: 50%;
  cursor: pointer;
  height: 16px;
  left: 3px;
  position: absolute;
  transition: all 200ms ease-in;
  width: 16px;
  z-index: 1;
`

export const Input = styled.input<InputProps>`
  cursor: pointer;
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 3;

  &:checked + ${Handle} {
    left: calc(100% - 18px);
  }
`

const StyledToggle = styled.div<StyledToggleBoxProps>`
  align-items: center;
  background: ${({ checked }) =>
    checked ? getToggleVariantProp('backgroundToggleActive') : getToggleVariantProp('backgroundToggleInactive')};
  border: 1px solid
    ${({ checked }) =>
      checked ? getToggleVariantProp('borderColorActive') : getToggleVariantProp('borderColorInactive')};
  border-radius: 11px;
  cursor: pointer;
  display: inline-flex;
  height: 24px;
  position: relative;
  transition: background-color 200ms;
  width: 40px;
`

export default StyledToggle
